module.exports = __webpack_public_path__ + "img/伊贝母.aefa43e6.jpg";